<script setup>
import { computed } from 'vue';

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
  createdAt: {
    type: [Number, String],
    default: null,
  },
});

const formattedTime = computed(() => {
  const value = Number(props.createdAt);
  if (!Number.isFinite(value) || value <= 0) return '';

  const date = new Date(value > 100000000000 ? value : value * 1000);
  return new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
});
</script>

<template>
  <div
    class="self-end box-border w-fit max-w-[86%] ltr:ml-8 rtl:mr-8 rounded-xl ltr:rounded-br-sm rtl:rounded-bl-sm border border-n-weak bg-n-alpha-3 px-3 py-2.5 text-n-slate-12"
  >
    <div
      v-if="message.context_label"
      class="mb-1.5 font-mono text-xs leading-4 text-n-slate-10"
    >
      {{ message.context_label }}
    </div>
    <div class="break-words whitespace-pre-wrap">
      {{ message.content }}
    </div>
    <time
      v-if="formattedTime"
      class="mt-2 block text-right text-xs leading-4 text-n-slate-10"
    >
      {{ formattedTime }}
    </time>
  </div>
</template>
